var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFaceNeutral = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16.29,
  cy: 16,
  r: 16,
  fill: "#F9A000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M20.97 12.76V15M12.01 12.76V15M19.64 20.026c-1.53 1.846-4.53 1.884-6.7.085"
})));
export default SvgFaceNeutral;